export default {
    status: {
        sent: 'Sent',
        failed: 'Failed',
        quarantined: 'Quarantined',
        spam: 'Spam',
    },
    /** Why a post was dropped before it was stored. */
    blockReason: {
        honeypot: 'bot trap',
        tooFast: 'sent too fast',
        replayed: 'sent twice',
        expired: 'form expired',
        invalid: 'invalid form data',
        csrf: 'session mismatch',
    },
    list: {
        title: 'Form submissions',
        allForms: 'All forms',
        anyStatus: 'Any status',
        quarantinedReview: 'Quarantined (review)',
        search: 'Search by sender email or name…',
        sender: 'Sender',
        blocked: 'Blocked in the last {days} days before reaching this list: {total} ({parts})',
        blockedPart: '{reason} {n}',
        empty: 'No submissions found.',
        form: 'Form',
        submitted: 'Submitted',
        unread: 'Unread',
        page: 'Page {page} of {pages}',
        count: 'no submissions | {n} submission | {n} submissions',
    },
    detail: {
        title: 'Submission #{id}',
        sending: 'Sending…',
        approve: 'Approve & send',
        rejecting: 'Rejecting…',
        reject: 'Reject as spam',
        resending: 'Resending…',
        resend: 'Resend',
        markUnread: 'Mark unread',
        markedUnread: 'Marked as unread',
        confirmDelete: 'Delete this submission? This cannot be undone.',
        sentOk: 'Submission sent successfully.',
        held: 'Held for review: flagged as possible spam (score {score})',
        notEmailed: 'This message was {not} emailed. Approve to send it, or reject to keep it marked spam.',
        notEmailedNot: 'not',
        form: 'Form',
        submitted: 'Submitted',
        to: 'To',
        subject: 'Subject',
        noFields: 'No field data.',
        attachments: 'Attachments ({n})',
        removed: 'removed {date} (retention expired)',
        downloading: 'Downloading…',
        notAvailable: 'Not available',
        showFull: 'Show {name} full size',
    },
};
